import { gql } from 'apollo-boost';

export const switchOffLimitPaymentDataQuery = gql`
    query SwitchOffLimitPaymentData($login: String!) {
        reqId: getReqId
        client(searchBy: { login: $login }) {
            autoOverdraftPaymentOptions {
                paymentMethods {
                    code
                    name
                    selected
                    limit
                }
                personInfo {
                    id
                    name
                    selected
                }
            }
        }
    }
`;
